<template>
<div class="chapter">
<div class="inner_page">
<div class="section1" id="calibre_pb_0">
<p class="xxlarge">
MY FOUR WEEKS<br class="calibre5"/>
IN FRANCE</p>
<p class="p"><i class="calibre6">By</i><br class="calibre7"/>
<span class="large">RING W. LARDNER</span><br class="calibre7"/>
</p>
<p class="p"><span class="xsmall">ILLUSTRATED BY</span><br class="calibre7"/>
<span class="large">WALLACE MORGAN</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section004.vue?0d5fbcb8